import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

const transferItemSchema = z.object({
  variant: zExt.objectId(),
  quantity: z.number().int().positive("Quantity must be positive"),
});

export const createInventoryTransfer = unaryRpc({
  name: "createInventoryTransfer",
  input: z.object({
    fromWarehouse: zExt.objectId(),
    toWarehouse: zExt.objectId(),
    sentItems: z
      .array(transferItemSchema)
      .min(1, "At least one item is required"),
    notes: z.array(z.string()).default([]),
    status: createEnum(["pending", "fulfilled", "arrived", "received"]).default(
      "pending",
    ),
  }),

  output: z.object({
    _id: zExt.objectId(),
    fromWarehouse: z.object({ _id: zExt.objectId(), name: z.string() }),
    toWarehouse: z.object({ _id: zExt.objectId(), name: z.string() }),
    sentItems: z.array(
      z.object({
        quantity: z.number(),
        variant: z.object({
          _id: zExt.objectId(),
          sku: z.string(),
          product: z.object({ _id: zExt.objectId(), name: z.string() }),
        }),
      }),
    ),
    receivedItems: z.array(
      z.object({
        quantity: z.number(),
        variant: z.object({
          _id: zExt.objectId(),
          sku: z.string(),
          product: z.object({ _id: zExt.objectId(), name: z.string() }),
        }),
      }),
    ),
    status: createEnum(["pending", "fulfilled", "arrived", "received"]),
    notes: z.array(z.string()),
    createdAt: z.string(),
    updatedAt: z.string(),
  }),
});
